import React, { useContext, useRef, useState } from 'react'
import BlueLogo from "../../assets/images/BlueLogo.svg";
import Input from '../../components/Input/Input';
import ApiService from '../../services/ApiService';
import MuiAlert from '../../components/Alert/Alert';
import { Link, useNavigate } from "react-router-dom";
import DocumentButton from '../../components/DocumentButton/DocumentButton';
import { obscureEmail, saveTokens, userEncrypt } from '../../helpers/HelperFunctions';
import { User } from '../../store/Store';
import { firebaseSignIn } from '../../helpers/FirebaseFunctions';
import OtpInput from 'react-otp-input';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

import "./Login.scss"

function Login() {

    const apiService = new ApiService();

    const [loading, setLoading] = useState(false);
    const [loginForm, setLoginForm] = useState({ email: "", password: "" });
    const [loginFormErrors, setLoginFormErrors] = useState({
        emailError: { showError: false, message: "" }, passwordError: { showError: false, message: "" }
    });
    const [showAlert, setShowAlert] = useState({ isError: false, message: "", open: false });
    const [showOtp, setShowOtp] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [otp, setOtp] = useState('');

    const otpRef = ({
        otp1: useRef(), otp2: useRef(), otp3: useRef(), otp4: useRef(), otp5: useRef(), otp6: useRef(),
        otp7: useRef(), otp8: useRef()
    })

    const [_, setUser] = useContext(User);

    const navigate = useNavigate();

    function sendOtp() {

        setLoading(true);


        if (otp.length != 8) {
            let newShowAlert = showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Invalid OTP";
            newShowAlert.open = true;
            setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
            setLoading(false);
            return;
        } else {
            let newShowAlert = showAlert;
            newShowAlert.open = false;
            setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
        }

        let data = {
            email: loginForm.email,
            otp: otp
        };

        apiService.login(data).then(async (result) => {

            let data = result.data;

            if (!data?.isSuccessful) {
                let newShowAlert = showAlert;
                newShowAlert.isError = true;
                newShowAlert.message = data?.errorMessage;
                newShowAlert.open = true;
                setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
                setLoading(false);
                return;
            }

            let firebaseLoginResult = await firebaseSignIn(data?.token)

            if (firebaseLoginResult) {
                saveTokens(data.token, data.refreshToken);
                setUser(data?.user);
                userEncrypt(data?.user);
                return navigate("/dashboard/home");
            } else {
                let newShowAlert = showAlert;
                newShowAlert.isError = true;
                newShowAlert.message = "Login Failed. Please Contact Your Administrator";
                newShowAlert.open = true;
                setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
            }
        }).catch(() => {
            let newShowAlert = showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Unexpected Error";
            newShowAlert.open = true;
            setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
        }).finally(() => {
            setLoading(false);
        })
    }

    function login() {

        setLoading(true);
        setOtp('');

        if (loginForm.email.trim() === "") {
            let newLoginFormErrors = loginFormErrors;
            newLoginFormErrors.emailError.showError = true;
            newLoginFormErrors.emailError.message = "REQUIRED";
            setLoginFormErrors(prevDetails => ({ ...prevDetails, ...newLoginFormErrors }));
            setLoading(false);
            return;
        } else {
            let newLoginFormErrors = loginFormErrors;
            newLoginFormErrors.emailError.showError = false;
            setLoginFormErrors(prevDetails => ({ ...prevDetails, ...newLoginFormErrors }));
        }

        if (loginForm.password.trim() === "") {
            let newLoginFormErrors = loginFormErrors;
            newLoginFormErrors.passwordError.showError = true;
            newLoginFormErrors.passwordError.message = "REQUIRED";
            setLoginFormErrors(prevDetails => ({ ...prevDetails, ...newLoginFormErrors }));
            setLoading(false);
            return;
        } else {
            let newLoginFormErrors = loginFormErrors;
            newLoginFormErrors.passwordError.showError = false;
            setLoginFormErrors(prevDetails => ({ ...prevDetails, ...newLoginFormErrors }));
        }

        let data = {
            email: loginForm.email,
            password: loginForm.password
        };

        apiService.otp(data).then((result) => {

            let data = result.data;

            if (!data?.isSuccessful) {
                let newShowAlert = showAlert;
                newShowAlert.isError = true;
                newShowAlert.message = data?.errorMessage;
                newShowAlert.open = true;
                setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
                setLoading(false);
                return;
            }

            setShowOtp(true);
        }).catch(() => {
            let newShowAlert = showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Unexpected Error";
            newShowAlert.open = true;
            setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
        }).finally(() => {
            setLoading(false);
        })
    }

    function loginFormContent() {
        return (
            <div >
                <div className="inputs">
                    <Input label='EMAIL ADDRESS' value={loginForm.email} type='text'
                        showError={loginFormErrors.emailError.showError}
                        onChange={(value: string) => {
                            let newLoginForm = loginForm;
                            newLoginForm.email = value;
                            setLoginForm(prevDetails => ({ ...prevDetails, ...newLoginForm }));
                        }} />
                </div>
                <div className="inputs">
                    <div className='password-wrapper'>
                        <Input label='PASSWORD' value={loginForm.password} type={showPassword ? 'text' : 'password'}
                            showError={loginFormErrors.passwordError.showError}
                            onChange={(value: string) => {
                                let newLoginForm = loginForm;
                                newLoginForm.password = value;
                                setLoginForm(prevDetails => ({ ...prevDetails, ...newLoginForm }));
                            }} />
                        {showPassword
                            ? <EyeInvisibleOutlined onClick={() => { setShowPassword(!showPassword) }} />
                            : <EyeOutlined onClick={() => { setShowPassword(!showPassword) }} />
                        }
                    </div>
                </div >
                <div className="footer">
                    {/* <div className='check-box'>
                        <CheckBox color='#EB6D26' checkedColore='#EB6D26' onChange={(value: any) => { }} />
                        <div className='remember'>Remember Password</div>
                    </div> */}
                    <label className='forget-password' onClick={() => { navigate("/forget-password") }}>Forgot Password?</label>

                </div>
                <div className="button-content">
                    <DocumentButton text='Login' loading={loading} onClick={() => { login(); }} />
                </div>
            </div>
        );
    }

    function OtpVerify() {
        return (
            <div className='otp-content'>
                <label className="title">OTP Verification</label>
                <label className="message">Enter the verification code sent to your email address</label>
                <label className="email">{obscureEmail(loginForm.email)}</label>

                <div className="otp-form">
                    <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={8}
                        renderInput={(props) => <input  {...props} />}
                    />
                </div>

                <label className="send-otp" onClick={() => { login(); }}>Resend OTP</label>

                <div className="button">
                    <DocumentButton text={"Verify"} onClick={() => { sendOtp(); }} loading={loading} />
                </div>

            </div>
        );
    }

    return (
        <div className='login-container'>
            <MuiAlert error={showAlert.isError} message={showAlert.message} open={showAlert.open}
                onClose={() => {
                    let newShowAlert = showAlert;
                    newShowAlert.open = false;
                    setShowAlert(prevDetails => ({ ...prevDetails, ...newShowAlert }));
                }} />
            <div className='login-body'>
                <div className="login-data">
                    <img src={BlueLogo} alt="Logo" />
                    <div className="text-content">
                        <span className='text-content-header'>Hello Again!</span>
                    </div>
                    {showOtp
                        ? (OtpVerify())
                        : (loginFormContent())
                    }
                </div>
            </div>
            <span className='footer-text'>
                {"© 2020 Scribe on Time Pty Ltd. All rights reserved. "}
                <Link className='privacy' target='_blank' to={'/privacy-policy'}>{"Privacy Policy"}</Link>
            </span>
        </div>
    )
}

export default Login